/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserCouponAvailablePageRespVo } from './GetUserCouponAvailablePageRespVo';
import {
    GetUserCouponAvailablePageRespVoFromJSON,
    GetUserCouponAvailablePageRespVoFromJSONTyped,
    GetUserCouponAvailablePageRespVoToJSON,
    GetUserCouponAvailablePageRespVoToJSONTyped,
} from './GetUserCouponAvailablePageRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetUserCouponAvailablePageRespVo
 */
export interface ResponseListGetUserCouponAvailablePageRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetUserCouponAvailablePageRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetUserCouponAvailablePageRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetUserCouponAvailablePageRespVo>}
     * @memberof ResponseListGetUserCouponAvailablePageRespVo
     */
    data?: Array<GetUserCouponAvailablePageRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetUserCouponAvailablePageRespVo interface.
 */
export function instanceOfResponseListGetUserCouponAvailablePageRespVo(value: object): value is ResponseListGetUserCouponAvailablePageRespVo {
    return true;
}

export function ResponseListGetUserCouponAvailablePageRespVoFromJSON(json: any): ResponseListGetUserCouponAvailablePageRespVo {
    return ResponseListGetUserCouponAvailablePageRespVoFromJSONTyped(json, false);
}

export function ResponseListGetUserCouponAvailablePageRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetUserCouponAvailablePageRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetUserCouponAvailablePageRespVoFromJSON)),
    };
}

export function ResponseListGetUserCouponAvailablePageRespVoToJSON(json: any): ResponseListGetUserCouponAvailablePageRespVo {
    return ResponseListGetUserCouponAvailablePageRespVoToJSONTyped(json, false);
}

export function ResponseListGetUserCouponAvailablePageRespVoToJSONTyped(value?: ResponseListGetUserCouponAvailablePageRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetUserCouponAvailablePageRespVoToJSON)),
    };
}

